<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Roagna</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In un mondo di moto perpetuo, dove l'uniformità è vista come una cosa negativa, grazie al cielo
                        “Roagna non cambia”. Oppure, come recita semplicemente il motto dell'azienda: Roagna non cambia. Come molti
                        dei grandi produttori piemontesi di Barolo e Barbaresco, Roagna è fedele alla tradizione,
                        mantenendo le convinzioni instillate in loro per decenni. "Non stiamo cercando di cambiare la storia qui", dice
                        Luca Roagna, quinta generazione di Roagna a lavorare nell'azienda di famiglia; “preferiremmo
                        contribuisci ad esso”. Quindi, quando si parla di vini piemontesi, c'è tradizionale, c'è
                        senza tempo e c'è Roagna.
                    </div>

                    <div class="howto-title2">È iniziato con un Barbaresco</div>
                    <div class="howto-text">
                        La storia di Roagna inizia nella regione piemontese del Barbaresco nel 1880, con Vincenzo e Rosa e la prima bottiglia di quella che sarebbe diventata una leggenda. Andando avanti di 40 anni fino al 1929
                        che vide l'acquisto della pregiata parcella di Montefico. Crescita costante in lotti storici
                        seguì poi, culminando nel 1989 quando Roagna, ora guidata da Alfredo (il grande di Vincenzo
                        nipote) si espanse nel Barolo con l'acquisizione di 12 ettari a Castiglione Falletto.
                        Introducendo la vinificazione in vigneto singolo, Alfredo ha continuato a produrre il puro ed espressivo
                        vino che era diventato sinonimo del nome di famiglia. Nonostante ogni generazione porti qualcosa
                        nuovi ai vini, seguivano tutti il motto di famiglia; infatti tanto semplice è quello di Roagna
                        dedizione a fornire il meglio che un clic del loro sito web (sorprendentemente moderno) può fare
                        di' a chiunque abbia cura di ascoltare i 10 comandamenti dai quali non deviano.
                        <br><br>
                        Nonostante sia devoto a "non cambiare" Luca, la quinta generazione a capo dell'azienda di famiglia lo ha
                        portato in agricoltura biologica, anche se non richiederà la certificazione. “Mi rifiuto di usare il
                        termine "biologico" come un modo per vendere bottiglie. Chi ci conosce conosce il nostro stile e il nostro
                        filosofia".
                    </div>

                    <div class="howto-title2">Un vino che vale la pena aspettare</div>
                    <div class="howto-text">
                        Roagna produce vini fatti per durare. Vengono prodotti venti diversi cru e xxx bottiglie
                        dai loro xxx ettari, il più famoso dei quali è senza dubbio il Barbaresco Crichët
                        Paje. Massicciamente esportato in Asia e negli Stati Uniti, gli investitori europei sarebbero fortunati a trovarne una bottiglia
                        meno di € 600 per le prime annate (come il 1982, punteggio complessivo: 90). Successivamente Luca ha guidato le annate
                        (come il 2010), che è stato invecchiato per otto anni e quindi le note di degustazione devono ancora uscire, ha
                        un prezzo di ingresso di € 650 a bottiglia in cauzione. Roagna ha altre tre bottiglie (Asili Vecchie Viti,
                        Montefico Vecchie Viti e Paje Vecchie Viti) nella classifica 2018 di wine-searcher.com dei più
                        vini costosi.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Roagna</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In einer Welt der ständigen Bewegung, in der Einheitlichkeit als eine schlechte Sache angesehen wird, ist das Gott sei Dank so
                        „Roagna non cambia“. Oder wie es im Firmenmotto einfach heißt: Roagna verändert sich nicht. Wie viele
                        Als einer der großen Barolo- und Barbaresco-Produzenten des Piemonts hält Roagna strikt an der Tradition fest.
                        Sie halten an den Überzeugungen fest, die ihnen über Jahrzehnte eingeflößt wurden. „Wir versuchen hier nicht, die Geschichte zu ändern“, sagt er
                        Luca Roagna, die fünfte Generation von Roagna, die im Familienunternehmen arbeitet; „Wir möchten lieber
                        dazu beitragen.“ Wenn es um piemontesische Weine geht, gibt es daher Tradition
                        zeitlos und es gibt Roagna.
                    </div>

                    <div class="howto-title2">Es begann mit einem Barbaresco</div>
                    <div class="howto-text">
                        Die Roagna-Geschichte beginnt in den 1880er Jahren in der Region Barbaresco im Piemont, mit Vincenzo und Rosa und der ersten Flasche dessen, was später zur Legende werden sollte. 40 Jahre vorwärts bis 1929
                        bei dem das wertvolle Montefico-Paket gekauft wurde. Stetiges Wachstum in historische Parzellen
                        Als nächstes folgte das Unternehmen, das 1989 seinen Höhepunkt erreichte, als Roagna, jetzt unter der Leitung von Alfredo (Vincenzos großer
                        Enkel) expandierte nach Barolo mit dem Erwerb von 12 Hektar in Castiglione Falletto.
                        Durch die Weinbereitung in einzelnen Weinbergen produzierte Alfredo weiterhin reine und ausdrucksstarke Weine
                        Wein, der zum Synonym für den Familiennamen geworden war. Obwohl jede Generation etwas bringt
                        Neu im Weinbereich folgten sie alle ihrem Familienmotto; Tatsächlich ist Roagna so einfach
                        Engagement dafür, das Beste zu liefern, was ein Klick auf ihre (überraschend moderne) Website bietet
                        Sagen Sie jedem, der darauf hören möchte, die 10 Gebote, von denen er nicht abweicht.
                        <br><br>
                        Trotz seiner Hingabe hat sich Luca, der das Familienunternehmen in der fünften Generation leitet, „nicht verändert“.
                        hat den ökologischen Landbau eingeführt, obwohl er die Zertifizierung nicht beantragen wird. „Ich weigere mich, das zu benutzen
                        Begriff „Bio“ als Möglichkeit, Flaschen zu verkaufen. Wer uns kennt, kennt unseren Stil und unsere
                        Philosophie".
                    </div>

                    <div class="howto-title2">Ein Wein, auf den sich das Warten lohnt</div>
                    <div class="howto-text">
                        Roagna produziert Weine, die auf Langlebigkeit ausgelegt sind. Es werden zwanzig verschiedene Crus und XXX-Flaschen produziert
                        Von ihren zwanzig Hektar ist die Barbaresco Crichët zweifellos die berühmteste
                        Pajé. Da es hauptsächlich nach Asien und in die USA exportiert wird, können europäische Investoren froh sein, eine Flasche zu finden
                        knapp 600 € für frühe Jahrgänge (z. B. 1982, Gesamtpunktzahl: 90). Später fuhr Luca Oldtimer
                        (z. B. 2010), der acht Jahre lang gereift war und daher noch keine Verkostungsnotizen veröffentlicht wurden
                        Ein Einstiegspreis von 650 € pro Flasche in Kaution. Roagna hat drei weitere Flaschen (Asili Vecchie Viti,
                        Montefico Vecchie Viti und Paje Vecchie Viti) auf der Wine-Searcher.com-Liste 2018 der besten Weine Italiens
                        teure Weine.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Roagna</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Dans un monde en mouvement perpétuel, où l'uniformité est considérée comme une mauvaise chose, Dieu merci,
                        "Roagna non cambia". Ou, comme le dit simplement la devise de l'entreprise : Roagna ne change pas. Comme beaucoup
                        des grands producteurs de Barolo et Barbaresco du Piémont, Roagna s'en tient farouchement à la tradition,
                        maintenir les croyances qui leur sont inculquées depuis des décennies. "Nous n'essayons pas de changer l'histoire ici", déclare
                        Luca Roagna, la cinquième génération de Roagnas à travailler dans l'entreprise familiale ; "Nous préférons
                        y contribuer. » Par conséquent, en matière de vins du Piémont, il y a la tradition, il y a
                        intemporel et il y a Roagna.
                    </div>

                    <div class="howto-title2">Tout a commencé avec un Barbaresco</div>
                    <div class="howto-text">
                        L'histoire de Roagna commence dans la région de Barbaresco du Piémont dans les années 1880, avec Vincenzo et Rosa et la première bouteille de ce qui allait devenir une légende. Avancer de 40 ans jusqu'en 1929
                        qui a vu l'achat de la précieuse parcelle de Montefico. Croissance régulière dans les parcelles historiques
                        suivi ensuite, culminant en 1989 lorsque Roagna, maintenant dirigée par Alfredo (le grand de Vincenzo
                        petit-fils) s'est étendu à Barolo avec l'acquisition de 12 acres à Castiglione Falletto.
                        En introduisant une vinification en vignoble unique, Alfredo a continué à produire des vins purs et expressifs
                        vin qui était devenu synonyme du nom de famille. Même si chaque génération apporte quelque chose
                        nouveaux dans les vins, ils ont tous suivi leur devise familiale ; en fait, si simple est Roagna
                        dévouement à fournir le meilleur qu'un seul clic de leur site Web (étonnamment moderne)
                        dites à qui veut bien écouter les 10 commandements dont ils ne s'écartent pas.
                        <br><br>
                        Bien qu'il soit dévoué à "ne pas changer" Luca, la cinquième génération à la tête de l'entreprise familiale a
                        introduit en agriculture biologique, bien qu'il ne demandera pas la certification. "Je refuse d'utiliser
                        terme "biologique" comme moyen de vendre des bouteilles. Tous ceux qui nous connaissent connaissent notre style et notre
                        philosophie".
                    </div>

                    <div class="howto-title2">Un vin qui vaut la peine d'attendre</div>
                    <div class="howto-text">
                        Roagna produit des vins construits pour durer. Vingt crus différents et xxx bouteilles sont produites
                        de leurs xxx hectares dont le plus célèbre est sans doute le Barbaresco Crichët
                        Pajé. Fortement exporté vers l'Asie et les USA, les investisseurs européens auraient de la chance de trouver une bouteille
                        moins de 600 € pour les millésimes précoces (comme 1982, note globale: 90). Plus tard, les millésimes conduits par Luca
                        (comme 2010), qui a vieilli huit ans et dont les notes de dégustation n'ont donc pas encore été publiées, a
                        un prix d'entrée de 650 € la bouteille sous caution. Roagna a trois autres bouteilles (Asili Vecchie Viti,
                        Montefico Vecchie Viti et Paje Vecchie Viti) sur la liste 2018 des vins les plus italiens de wine-searcher.com
                        vins chers.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Roagna</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        In a world of perpetual motion, where uniformity is seen as a bad thing, thank goodness that
                        “Roagna non cambia”. Or, as the company’s motto simply states: Roagna doesn’t change. Like many
                        of the great Barolo and Barbaresco producers of Piedmont, Roagna sticks fiercely to tradition,
                        maintaining beliefs instilled in them for decades.“We're not trying to change history here” says
                        Luca Roagna, the fifth generation of Roagnas to work in the family business; “we'd rather
                        contribute to it.” Therefore, when it comes to Piedmont wines, there is traditional, there is
                        timeless and there is Roagna.
                    </div>

                    <div class="howto-title2">It started with a Barbaresco</div>
                    <div class="howto-text">
                        The Roagna story begins in the Barbaresco region of Piedmont in the 1880s, with Vincenzo and Rosa and the first bottle of what would go on to be a legend. Moving forward by 40 years to 1929
                        which saw the purchase of the prized Montefico parcel. Steady growth into historic parcels
                        followed next, culminating in 1989 when Roagna, now being run by Alfredo (Vincenzo’s great
                        grandson) expanded into Barolo with the acquisition of 12-acres in Castiglione Falletto.
                        Bringing in single vineyard vinification, Alfredo continued producing the pure and expressive
                        wine that had become synonymous with the family name. Despite each generation bringing something
                        new to the wines, they all followed their family motto; in fact, so simple is Roagna’s
                        dedication to delivering the best that one click of their (surprisingly modern) website will
                        tell anyone who cares to listen the 10 commandments from which they do not deviate.
                        <br><br>
                        Despite being devoted “not changing” Luca, the fifth generation to head the family business has
                        brought in organic farming, although he will not request the certification. “I refuse to use the
                        term "organic" as a way to sell bottles. Anyone who knows us knows our style and our
                        philosophy”.
                    </div>

                    <div class="howto-title2">A wine worth waiting for</div>
                    <div class="howto-text">
                        Roagna produce wines that are built to last. Twenty different crus and xxx bottles are produced
                        from their xxx hectares, the most famous of which is without doubt is the Barbaresco Crichët
                        Pajé. Heavily exported to Asia and the US, European investors would be lucky to find a bottle
                        shy of €600 for early vintages (such as 1982, aggregate score:90). Later Luca driven vintages
                        (such as 2010), which was aged for eight years and thus tasting notes have yet to come out, has
                        an entry price of €650 per bottle in bond. Roagna has three other bottles (Asili Vecchie Viti,
                        Montefico Vecchie Viti and Paje Vecchie Viti) on wine-searcher.com’s 2018 list of Italy’s most
                        expensive wines.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Roagna",
    head: {
        title: 'Roagna | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Roagna wine producer, offering a range of highly sought-after Piedmont wines made from carefully selected grapes grown in the region\'s fertile vineyards. Savor the unique terroir and taste of this prestigious producer\'s rich, full-bodied red wines and elegant whites.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
